import { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import LogoutButton from "./LogoutButton";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import logo from "../assets/images/logo-transparent.png"; // Adjust the path as necessary

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [user] = useAuthState(auth);
  const location = useLocation();

  const navItems = [
    { name: 'Home', href: '/', path: '/' },
    { name: 'Lessons', href: '/Lessons', path: '/Lessons' },
    { name: 'About', href: '/About', path: '/About' },
    { name: 'Contact', href: '/Contact', path: '/Contact' }
  ];

  return (
    <>
      <header role="banner">
        <nav className="bg-transparent" aria-label="Primary Navigation">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center space-x-8">
                <div className="flex-shrink-0">
                  <img
                    className="h-20 w-auto"
                    src={logo}
                    alt="Learners Rider Logo"
                  />
                </div>

                <div className="hidden md:flex items-center space-x-6">
                  {navItems.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200 ${
                        location.pathname === item.path ? 'text-blue-600 font-semibold' : ''
                      }`}
                      aria-current={location.pathname === item.path ? "page" : undefined}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>

              <div className="hidden md:block">
                {user ? (
                  <LogoutButton className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200" />
                ) : (
                  <Link
                    to="/login"
                    className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200"
                  >
                    Login
                  </Link>
                )}
              </div>

              <div className="md:hidden">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  aria-label="Toggle Navigation Menu"
                  className="text-gray-700 hover:text-gray-900 transition-colors duration-200"
                >
                  ☰
                </button>
              </div>
            </div>

            {isOpen && (
              <div className="md:hidden py-4 space-y-2">
                {navItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`block text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200 ${
                      location.pathname === item.path ? 'text-blue-600 font-semibold' : ''
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
                {user ? (
                  <LogoutButton className="block text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200 mt-2" />
                ) : (
                  <Link
                    to="/login"
                    className="block text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200 mt-2"
                  >
                    Login
                  </Link>
                )}
              </div>
            )}
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
